export default "__VITE_ASSET__CSIaQd02__"